import { Link } from "react-router-dom";
import { FaArrowRight } from "react-icons/fa";
import { blogPosts } from "../data/blogData"; // import data blog hiện có

const NewsSection = () => {
  // Chuyển blogPosts sang cấu trúc cũ
  const newsData = blogPosts.slice(0, 3).map((post) => ({
    id: post.id,
    date: post.date,
    title: post.title,
    img: post.homeImg, // lấy ảnh chính
    link: `/bai-viet/${post.slug}`, // link đúng route tiếng Việt
  }));

  return (
    <section className="news-section fix section-padding">
      <div className="container">
        {/* Section Title */}
        <div className="section-title-area">
          <div className="section-title">
            <h6 className="wow fadeInUp">Blog & Tin Tức</h6>
            <h2
              className="wow fadeInUp"
              data-wow-delay=".3s"
            >
              Tin Tức Mới Nhất & <span>Blog</span>
            </h2>
          </div>
          <Link
            to="/bai-viet"
            className="theme-btn wow fadeInUp"
            data-wow-delay=".5s"
          >
            Xem Tất Cả Blog
          </Link>
        </div>

        {/* News Items */}
        <div className="row">
          {newsData.map((news, index) => (
            <div
              key={news.id}
              className="col-xl-4 col-lg-6 col-md-6 wow fadeInUp"
              data-wow-delay={`${0.3 + index * 0.2}s`}
            >
              <div className="news-box-items">
                {/* Image */}
                <div className="news-image">
                  <img
                    src={news.img}
                    alt={news.title}
                  />
                  <img
                    src={news.img}
                    alt={`${news.title} hover`}
                  />
                </div>

                {/* Content */}
                <div className="news-content">
                  <p>{news.date}</p>
                  <h3>
                    <Link to={news.link}>{news.title}</Link>
                  </h3>
                  <div className="news-btn">
                    <Link
                      to={news.link}
                      className="link-btn"
                    >
                      Xem Chi Tiết
                    </Link>
                    <Link
                      to={news.link}
                      className="arrow-icon"
                    >
                      <FaArrowRight />
                    </Link>
                  </div>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default NewsSection;
